import { CategoryId } from '@/config/constants';
import { getAllCombinedCategoryIds } from '@/pages/Jar/jar.constants';

const DANGEROUS_CHARS_REGEX = /[<>'"&;(){}[\]\\|`~!@#$%^*+=]/g;

const VALID_CATEGORY_IDS = new Set([
  CategoryId.Academics,
  CategoryId.Athletics,
  CategoryId.ArtsAndCulture,
  CategoryId.CollegeAndCareer,
  CategoryId.SchedulesAndInformation,
  CategoryId.HealthAndSafety,
  CategoryId.StudentOrganizations,
  CategoryId.FamilySupport,
  CategoryId.VolunteerAndFundraising,
  CategoryId.Sports,
  CategoryId.RecreationAndDiscovery,
  CategoryId.VolunteerAndLocalService,
  CategoryId.YouthOrganizations,
  ...getAllCombinedCategoryIds(),
]);

export const isValidCategoryId = (categoryId: string | null): boolean => {
  if (!categoryId || typeof categoryId !== 'string') {
    return false;
  }

  if (DANGEROUS_CHARS_REGEX.test(categoryId)) {
    return false;
  }

  return VALID_CATEGORY_IDS.has(categoryId);
};

export const sanitizeCategoryId = (categoryId: string | null): string | null => {
  if (!categoryId || typeof categoryId !== 'string') {
    return null;
  }

  const sanitized = categoryId.replace(DANGEROUS_CHARS_REGEX, '');
  
  return isValidCategoryId(sanitized) ? sanitized : null;
};

export const sanitizeText = (text: string): string => {
  if (!text || typeof text !== 'string') {
    return '';
  }

  const sanitized = text.replace(DANGEROUS_CHARS_REGEX, '');
  
  return sanitized.trim().substring(0, 1000);
};

export const validateAndSanitizeURLParams = (searchParams: URLSearchParams) => {
  const categoryId = searchParams.get('categoryId');
  const categoryName = searchParams.get('categoryName');
  const audienceId = searchParams.get('audienceId');
  const audienceType = searchParams.get('audienceType');

  return {
    categoryId: sanitizeCategoryId(categoryId),
    categoryName: categoryName ? sanitizeText(categoryName).substring(0, 200) : null,
    audienceId: audienceId ? sanitizeText(audienceId).substring(0, 50) : 'all',
    audienceType: audienceType === 'district' ? 'district' : 'school',
  };
};